import DanThuocPage from "./DanhThuocPage";

export default DanThuocPage